import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/pages/home/home'
// import PersonalAchievement from '../views/pages/achievement/personal-achievement'
// import PartnerAchievement from '../views/pages/achievement/partner-achievement'
// import ProfitGeneralBill from '../views/pages/profit/bill-general'
// import ProfitWpBill from '../views/pages/profit/bill-wp'

const Home = () => import('../views/pages/home/home')
const PersonalAchievement = () =>
  import('../views/pages/achievement/personal-achievement')
const PartnerAchievement = () =>
  import('../views/pages/achievement/partner-achievement')
const PartnerAchievementRevision = () =>
  import('../views/pages/achievement/partner-achievement-revision')
const PersonalAchievementRevision = () =>
  import('../views/pages/achievement/personal-achievement-revision')
const TeamAchievement = () =>
  import('../views/pages/achievement/team-achievement')
const ProfitGeneralBill = () => import('../views/pages/profit/bill-general')
const ProfitGeneralBillRevision = () =>
  import('../views/pages/profit/bill-general-revision')
const ProfitWpBillRevision = () =>
  import('../views/pages/profit/bill-wp-revision')
const ProfitWpBill = () => import('../views/pages/profit/bill-wp')
const InvoiceDetail = () => import('@/views/pages/invoice/detail')
const InvoiceStatementList = () =>
  import('@/views/pages/invoice/statement-list')
const InvoiceStatement = () => import('@/views/pages/invoice/statement')
const PartnerDetail = () => import('@/views/pages/home/partner-detail')
const MerchantDetail = () => import('@/views/pages/home/merchant-detail')
const ThirtyDetails = () => import('@/views/pages/home/thirty-details')
const IncrementalAward = () => import('@/views/pages/my/incremental-award')

/** 旺铺管家 */

const WpPartnerAchievement = () =>
  import('@/views/pages/wp/achievement/partner-achievement')
const WpPartnerAchievementRevision = () =>
  import('@/views/pages/wp/achievement/partner-achievement-revision')
const WpPersonalAchievement = () =>
  import('@/views/pages/wp/achievement/personal-achievement')
const WpPersonalAchievementRevision = () =>
  import('@/views/pages/wp/achievement/personal-achievement-revision')
const WpTeamAchievement = () =>
  import('@/views/pages/wp/achievement/team-achievement')
const WpPartnerDetail = () => import('@/views/pages/wp/partner-detail')
const WpMerchantDetail = () => import('@/views/pages/wp/merchant-detail')
const WpProfitGeneralBill = () => import('@/views/pages/wp/profit/bill-general')
const WpProfitGeneralBillRevision = () =>
  import('@/views/pages/wp/profit/bill-general-revision')
const WpProfitWpBillRevision = () =>
  import('@/views/pages/wp/profit/bill-wp-revision')
const WpProfitWpBill = () => import('@/views/pages/wp/profit/bill-wp')
// Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: '首页-喔刷伙伴'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页-喔刷伙伴'
    }
  },
  {
    path: '/personal-achievement',
    name: 'personal-achievement',
    component: PersonalAchievement,
    meta: {
      title: '个人业绩'
    }
  },
  {
    path: '/partner-achievement',
    name: 'partner-achievement',
    component: PartnerAchievement,
    meta: {
      title: '服务商业绩'
    }
  },
  {
    path: '/team-achievement',
    name: 'team-achievement',
    component: TeamAchievement,
    meta: {
      title: '团队业绩'
    }
  },
  {
    path: '/personal-achievement-revision',
    name: 'personal-achievement-revision',
    component: PersonalAchievementRevision,
    meta: {
      title: '个人业绩'
    }
  },
  {
    path: '/partner-achievement-revision',
    name: 'partner-achievement-revision',
    component: PartnerAchievementRevision,
    meta: {
      title: '服务商业绩'
    }
  },
  {
    path: '/profit-bill-general',
    name: 'profit-bill-general',
    component: ProfitGeneralBill,
    meta: {
      title: '分润账单'
    }
  },
  {
    path: '/profit-bill-general-revision',
    name: 'profit-bill-general-revision',
    component: ProfitGeneralBillRevision,
    meta: {
      title: '分润账单'
    }
  },
  {
    path: '/profit-bill-wp',
    name: 'profit-bill-wp',
    component: ProfitWpBill,
    meta: {
      title: '旺铺分润账单'
    }
  },
  {
    path: '/profit-bill-wp-revision',
    name: 'profit-bill-wp-revision',
    component: ProfitWpBillRevision,
    meta: {
      title: '分润账单'
    }
  },
  {
    path: '/invoice-detail',
    name: 'invoice-detail',
    component: InvoiceDetail,
    meta: {
      title: '发票详情'
    }
  },
  {
    path: '/invoice-statement-list',
    name: 'invoice-statement-list',
    component: InvoiceStatementList,
    meta: {
      title: '结算单'
    }
  },
  {
    path: '/invoice-statement',
    name: 'invoice-statement',
    component: InvoiceStatement,
    meta: {
      title: '结算单'
    }
  },
  {
    path: '/partner-detail',
    name: 'partner-detail',
    component: PartnerDetail,
    meta: {
      title: '服务商详情'
    }
  },
  {
    path: '/merchant-detail',
    name: 'merchant-detail',
    component: MerchantDetail,
    meta: {
      title: '商户详情'
    }
  },
  {
    path: '/change-device',
    name: 'change-device',
    component: () => import('@/views/pages/home/change-device'),
    meta: {
      title: '机具换绑'
    }
  },
  {
    path: '/change-device-next',
    name: 'change-device-next',
    component: () => import('@/views/pages/home/change-device-next'),
    meta: {
      title: '机具换绑'
    }
  },
  {
    path: '/thirty-details',
    name: 'thirty-details',
    component: ThirtyDetails,
    meta: {
      title: '激活后30天内交易明细'
    }
  },
  {
    path: '/incremental-award',
    name: 'incremental-award',
    component: IncrementalAward,
    meta: {
      title: '我的增量奖'
    }
  },
  {
    path: '/wp/partner-detail',
    name: 'wp-partner-detail',
    component: WpPartnerDetail,
    meta: {
      title: '服务商详情'
    }
  },
  {
    path: '/wp/merchant-detail',
    name: 'wp-merchant-detail',
    component: WpMerchantDetail,
    meta: {
      title: '商户详情'
    }
  },
  {
    path: '/wp/personal-achievement',
    name: 'wp-personal-achievement',
    component: WpPersonalAchievement,
    meta: {
      title: '个人业绩'
    }
  },
  {
    path: '/wp/partner-achievement',
    name: 'wp-partner-achievement',
    component: WpPartnerAchievement,
    meta: {
      title: '服务商业绩'
    }
  },
  {
    path: '/wp/team-achievement',
    name: 'wp-team-achievement',
    component: WpTeamAchievement,
    meta: {
      title: '团队业绩'
    }
  },
  {
    path: '/wp/personal-achievement-revision',
    name: 'wp-personal-achievement-revision',
    component: WpPersonalAchievementRevision,
    meta: {
      title: '个人业绩'
    }
  },
  {
    path: '/wp/partner-achievement-revision',
    name: 'wp-partner-achievement-revision',
    component: WpPartnerAchievementRevision,
    meta: {
      title: '服务商业绩'
    }
  },
  {
    path: '/wp/profit-bill-general',
    name: 'wp-profit-bill-general',
    component: WpProfitGeneralBill,
    meta: {
      title: '分润账单'
    }
  },
  {
    path: '/wp/profit-bill-general-revision',
    name: 'wp-profit-bill-general-revision',
    component: WpProfitGeneralBillRevision,
    meta: {
      title: '分润账单'
    }
  },
  {
    path: '/wp/profit-bill-wp',
    name: 'wp-profit-bill-wp',
    component: WpProfitWpBill,
    meta: {
      title: '旺铺分润账单'
    }
  },
  {
    path: '/wp/profit-bill-wp-revision',
    name: 'wp-profit-bill-wp-revision',
    component: WpProfitWpBillRevision,
    meta: {
      title: '分润账单'
    }
  },
  {
    path: '/auth-failed',
    name: 'auth-failed',
    component: () =>
      import(
        /* webpackChunkName: "assist-operation" */ '@/views/pages/assist-operation/auth-failed'
      ),
    meta: {
      title: '认证失败'
    }
  },
  {
    path: '/supply-info/idcard',
    name: 'supply-info-idcard',
    component: () =>
      import(/* webpackChunkName: "idcard" */ '@/views/pages/supply-info/idcard'),
    meta: {
      title: '信息补录'
    }
  },
  {
    path: '/supply-info/index',
    name: 'supply-info-index',
    component: () =>
      import(/* webpackChunkName: "idcard" */ '@/views/pages/supply-info/index'),
    meta: {
      title: '信息补录'
    }
  },
  {
    path: '/supply-info/bankcard',
    name: 'supply-info-bankcard',
    component: () =>
      import(/* webpackChunkName: "idcard" */ '@/views/pages/supply-info/bankcard'),
    meta: {
      title: '信息补录'
    }
  },
  {
    path: '/supply-info/face',
    name: 'supply-info-face',
    component: () =>
      import(/* webpackChunkName: "idcard" */ '@/views/pages/supply-info/face'),
    meta: {
      title: '信息补录'
    }
  },
  {
    path: '/assist-operation',
    name: 'assist-operation',
    component: () =>
      import(
        /* webpackChunkName: "assist-operation" */ '@/views/pages/assist-operation/index'
      ),
    meta: {
      title: '协助进件'
    }
  },
  {
    path: '/assist-operation/result',
    name: 'assist-operation-result',
    component: () =>
      import(
        /* webpackChunkName: "assist-operation" */ '@/views/pages/assist-operation/result'
      ),
    meta: {
      title: '协助进件'
    }
  },
  {
    path: '/assist-operation/choose-sn',
    name: 'assist-operation-choose-sn',
    component: () =>
      import(
        /* webpackChunkName: "assist-operation" */ '@/views/pages/assist-operation/choose-sn'
      ),
    meta: {
      title: '协助进件'
    }
  }
]

// const router = new VueRouter({
//   mode: 'history',
//   routes
// })

export default routes
